import React from 'react';
import {Button, Typography} from "@material-ui/core";
import  profileImage  from "../../assets/images/profile1.jpeg"
import './profile.css'
import CustomTimeline, {CustomTimelineSeparator} from "../Timeline/CustomTimeline";
import ResumeData from "../utils/ResumeData";
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineContent from "@material-ui/lab/TimelineContent";
import CustomButton from "../Button/Button";
import GetAppIcon from '@material-ui/icons/GetApp';

const CustomTimelineItem = ({title,link,text}) => (
     <TimelineItem>
         <CustomTimelineSeparator />
         <TimelineContent className={'timeline_content'}>
             {link ? (
                 <Typography className={'timelineItem_text'}>
                     <span> {title.charAt(0).toUpperCase() + title.slice(1)}:</span> <a target='_blank'  href={link}>{text}</a>
                 </Typography>
                 ) :
                 (
                     <Typography className={'timelineItem_text'}><span>{title}:</span>{text}</Typography>
                 )
             }
         </TimelineContent>
     </TimelineItem>
)

function Profile(props) {
    return (
        <div className="profile container_shadow">
            <div className="profile_name">
              <Typography className="name">{ResumeData.name}</Typography>
              <Typography className="title">{ResumeData.title}</Typography>
            </div>
            <figure className="profile_img">
                <img src={profileImage} alt=""/>
            </figure>
            <div className="profile_information">
                <CustomTimeline icon={<PersonOutlineIcon />}>
                     <CustomTimelineItem title='Name' text={ResumeData.name} ></CustomTimelineItem>
                     <CustomTimelineItem title='Title' text={ResumeData.title} ></CustomTimelineItem>
                     <CustomTimelineItem title='Email' text={ResumeData.email} ></CustomTimelineItem>
                    {Object.keys(ResumeData.socials).map((key) => (
                        <CustomTimelineItem title={key} text={ResumeData.socials[key].text} link={ResumeData.socials[key].link} ></CustomTimelineItem>
                    ))}
                </CustomTimeline>
                  <div className={'btn_container'}>
                 {/*<CustomButton text={'Download Cv'} icon={<GetAppIcon />} />*/}
                      <a target="_blank" href={ResumeData.cv} className="custom_btn custom_btn_link"  >
                          <span className='btn_text'>Download Cv <GetAppIcon /> </span>
                      </a>
            </div>
            </div>
        </div>
    );
}

export default Profile;